import { useState, useEffect } from "react";
import type { DbMember } from "@/types/database";
import { supabase } from "@/lib/supabase";

interface UseMembersReturn {
  founders: DbMember[];
  active: DbMember[];
  alumni: DbMember[];
  isLoading: boolean;
}

export function useMembers(): UseMembersReturn {
  const [founders, setFounders] = useState<DbMember[]>([]);
  const [active, setActive] = useState<DbMember[]>([]);
  const [alumni, setAlumni] = useState<DbMember[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function load() {
      const { data, error } = await supabase
        .from("members")
        .select("*")
        .eq("is_visible", true)
        .order("sort_order", { ascending: true });

      if (!mounted) return;

      if (error) {
        console.error("Failed to fetch members:", error.message);
        setIsLoading(false);
        return;
      }

      const members = data as DbMember[];
      setFounders(members.filter((m) => m.category === "founder"));
      setActive(members.filter((m) => m.category === "active"));
      setAlumni(members.filter((m) => m.category === "alumni"));
      setIsLoading(false);
    }

    load();

    return () => {
      mounted = false;
    };
  }, []);

  return { founders, active, alumni, isLoading };
}
